import { EntraGroupsRoute } from "@/routes/base-data/auth/entra/entra-groups/entra-groups-route";

export const entraRoutes = [
  {
    path: "entra-groups",
    element: <EntraGroupsRoute />,
  },
];
